// extracted by mini-css-extract-plugin
module.exports = {"root":"TypesInfo_root__2YkgN","title":"TypesInfo_title__ysUR9","types":"TypesInfo_types__u1eIJ","type":"TypesInfo_type__2RWwo"};